import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var pencil_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "m19 7-3-3-8.5 8.5-1 4 4-1L19 7Zm-7 11.5H5V20h7v-1.5Z" }) });
export {
  pencil_default as default
};
//# sourceMappingURL=pencil.js.map
